import './skeleton.css';

/**
 * Shimmer placeholders. See skeleton.css for the rules.
 *
 * <Skeleton> is one bar. Its shape and width are classes, not inline
 * sizes: line | title | figure | row | search | tab | pill | mark | ring
 * | chart | gauge, and width 25 | 40 | 55 | 70 | 85 | 100 (percent).
 * tone="dark" is for the rail-coloured hero boxes.
 *
 * <SkeletonGroup> wraps a whole loading region: it is what a screen
 * reader hears ("Loading the dashboard"), and the bars inside are hidden
 * from it. Pass the real frame's class (className="ov", "tfr-grid"...) so
 * the placeholder takes the same layout as what it stands in for.
 */

const cx = (...parts) => parts.filter(Boolean).join(' ');

export const Skeleton = ({ shape = 'line', width, tone, className }) => (
  <span
    className={cx(
      'lms-skel',
      `lms-skel--${shape}`,
      width && `lms-skel--w${width}`,
      tone === 'dark' && 'lms-skel--on-dark',
      className,
    )}
    aria-hidden="true"
  />
);

export const SkeletonGroup = ({ label = 'Loading', className, as: Tag = 'div', children }) => (
  <Tag
    className={cx('lms-skel-group', className)}
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <span className="lms-skel-sr">{label}</span>
    {children}
  </Tag>
);

export default Skeleton;
